import LIcon from "@components/LIcon";
import LPressable from "@components/LPressable";
import { useShare } from "@hooks/trpc/useShare";

type ArtistShareButtonProps = {
  artist: {
    id: string;
    image: string | null;
    name: string;
  };
};

const ArtistShareButton = ({ artist }: ArtistShareButtonProps) => {
  const share = useShare();

  return (
    <LPressable
      accessibilityLabel="Share artist"
      accessibilityRole="button"
      disabled={share.isPending}
      hitSlop={12}
      onPress={() => {
        share.mutate({
          linkType: "direct-link",
          contentType: "artist",
          data: {
            id: artist.id,
            imageUrl: artist.image,
            name: artist.name,
          },
        });
      }}
      sentryEventName="share_collection"
      style={{ opacity: share.isPending ? 0.5 : 1 }}
    >
      <LIcon name="share" size={24} />
    </LPressable>
  );
};

export default ArtistShareButton;
